import React from 'react';
import { Link } from 'react-router-dom';
import ButtonPrimary from '../buttons/ButtonPrimary';
import './Topbar.css';  // Assuming you might want separate styles for the top bar

const logoText = require('../../assets/images/logo_text_sm.png');

function Topbar() {
    return (
        <div className="top-bar">
            <div className="container d-flex justify-content-between align-items-center py-2">
                <div className="logo">
                    <img src={logoText} alt="Takomori Logo" style={{ height: '20px' }} />
                </div>
                <div className="auth-links">
                    <span className="d-none d-md-block">Want to track your learning progress?</span>
                    <div className="auth-buttons">
                        <Link to='/login'>
                            <ButtonPrimary type="submit" value="Login" fontSize="14px" padding="0px 15px" height="30px" className="tkmr-btn-auto-fit" />
                        </Link>
                        <span className="mx-1">or</span>
                        <Link to='/login?register=true'>
                            <ButtonPrimary type="submit" value="Register" fontSize="14px" padding="0px 15px" height="30px" className="tkmr-btn-auto-fit" />
                        </Link>
                    </div>
                </div>
            </div>
            <hr />
        </div>
    );
}

export default Topbar;
